var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-heading',[_vm._v("Generic.Pages.functional")]),_c('doc-text',[_vm._v(_vm._s((_vm.namespace + "." + _vm.page + ".functional.desc")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }